var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ValidationObserver", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ handleSubmit }) {
          return [
            _c("ValidationProvider", {
              attrs: { name: "Title", rules: "required_field" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ errors }) {
                      return [
                        _c("FormGroup", {
                          attrs: {
                            title: "",
                            name: "title",
                            isIcon: false,
                            inputClass: "fullwidthInput",
                            placeholder: "Enter title",
                            errors: errors,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("p", { staticClass: "mb-2" }, [
                                      _c(
                                        "span",
                                        { staticClass: "required-icon" },
                                        [_vm._v("*")]
                                      ),
                                      _vm._v(" Title "),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: _vm.title,
                            callback: function ($$v) {
                              _vm.title = $$v
                            },
                            expression: "title",
                          },
                        }),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            }),
            _c("ValidationProvider", {
              attrs: {
                name: "Certification institution",
                rules: "required_field",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ errors }) {
                      return [
                        _c("FormGroup", {
                          attrs: {
                            title: "",
                            isIcon: false,
                            inputClass: "fullwidthInput",
                            name: "certification institution",
                            placeholder: "Enter institution",
                            errors: errors,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("p", { staticClass: "mb-2" }, [
                                      _c(
                                        "span",
                                        { staticClass: "required-icon" },
                                        [_vm._v("*")]
                                      ),
                                      _vm._v(" Institution "),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: _vm.institution,
                            callback: function ($$v) {
                              _vm.institution = $$v
                            },
                            expression: "institution",
                          },
                        }),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            }),
            _c(
              "div",
              { staticClass: "mt-1 grid grid-cols-2 gap-8" },
              [
                _c("ValidationProvider", {
                  attrs: { vid: "start_date", name: "Start date" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ errors }) {
                          return [
                            _c(
                              "FormGroup",
                              {
                                attrs: {
                                  title: "Start Date",
                                  name: "start date",
                                  errors: errors,
                                },
                              },
                              [
                                _c("FormDatepicker", {
                                  attrs: { heightClass: "datePickerHeight" },
                                  model: {
                                    value: _vm.startDate,
                                    callback: function ($$v) {
                                      _vm.startDate = $$v
                                    },
                                    expression: "startDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c("ValidationProvider", {
                  attrs: {
                    rules: "noBeforeDate:@start_date",
                    name: "End date",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ errors }) {
                          return [
                            _c(
                              "FormGroup",
                              {
                                attrs: {
                                  title: "End Date",
                                  name: "end date",
                                  errors: errors,
                                },
                              },
                              [
                                _c("FormDatepicker", {
                                  attrs: {
                                    name: "end date",
                                    errors: errors,
                                    heightClass: "datePickerHeight",
                                  },
                                  model: {
                                    value: _vm.endDate,
                                    callback: function ($$v) {
                                      _vm.endDate = $$v
                                    },
                                    expression: "endDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pt-5 flex justify-end" },
              [
                _c("UIButton", {
                  staticClass: "mr-3",
                  attrs: {
                    variant: "outline",
                    size: "lg",
                    buttonText: "Cancel",
                  },
                  on: { click: _vm.closeModal },
                }),
                _vm.isEditing
                  ? _c("UIButton", {
                      attrs: {
                        variant: "black",
                        size: "lg",
                        buttonText: "Update",
                        processing: _vm.processing,
                      },
                      on: {
                        click: function ($event) {
                          return handleSubmit(_vm.submit)
                        },
                      },
                    })
                  : _c("UIButton", {
                      attrs: {
                        buttonText: "Add",
                        variant: "black",
                        size: "lg",
                        processing: _vm.processing,
                      },
                      on: {
                        click: function ($event) {
                          return handleSubmit(_vm.submit)
                        },
                      },
                    }),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }